import isElectron from 'is-electron'
import isWindows from 'is-windows'
import React, { Component } from 'react';
import ReactTooltip from 'react-tooltip'
import ReactModal from 'react-modal'
import classnames from 'classnames'
// components
import EditorHeader from './components/EditorHeader'
import EditorBody from './components/EditorBody'
import MalletStationListener from './components/device/MalletStationListener'
// modals
import './components/UI/ReactModal.css'
import VelocityCurves from './components/VelocityCurves'
import Preferences from './components/Preferences'
import PresetsImportRenameDialog from './components/PresetsImportRenameDialog'
import LearnMode from './components/LearnMode'

class App extends Component {
  componentDidMount(){
    ReactModal.setAppElement('#root')
  }

  render() {
    return (
      <div className={
        classnames(
          'editor',
          {'electron': isElectron()},
          {'windows': isElectron() ? isWindows() : window.navigator.platform.includes('Win')}
        )
      }>
        <MalletStationListener />
        <EditorHeader />
        <EditorBody />
        <VelocityCurves />
        <Preferences />
        <PresetsImportRenameDialog />
        <LearnMode />
        <ReactTooltip
          place="bottom"
          type="light"
          effect="solid"
        />
      </div>
    );
  }
}

export default App;
